import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Image from "next/image";

const BlueBoxImageAndText = ({ children, image, className = "" }) => {
  return (
    <section className={`blue-box-image-text-container ${className}`.trim()}>
      <Container>
        <Row>
          <Col md={6} className="mb-6 mb-md-0">
            <div className="blue-image-container">
              <Image src={image} width={792} height={640} unoptimized={true} />
            </div>
          </Col>
          <Col md={6} className="d-flex align-items-center">
            <Col md={10}>{children}</Col>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default BlueBoxImageAndText;
